import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import clsx from "clsx";
import { useCallback, useEffect, useRef, useState, } from "react";
import { createPortal } from "react-dom";
export const Menu = ({ isOpen, onClose, renderButton, placementX, placementY = "auto", size, className, children, }) => {
    const menuRef = useRef(null);
    const portalRef = useRef(null);
    const containerRef = useRef(null);
    const [offsets, setOffsets] = useState({
        offsetLeft: 0,
        offsetTop: 0,
    });
    const [maxHeight, setMaxHeight] = useState();
    const recalculatePosition = useCallback(() => {
        if (containerRef.current && menuRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const menuRect = menuRef.current.getBoundingClientRect();
            let offsetTop = containerRect.bottom + 5;
            // let offsetTop = containerRect.bottom + document.documentElement.scrollTop + 5;
            const offsetLeft = containerRect.left +
                (placementX === "right" ? containerRect.width - menuRect.width : 0);
            // + document.documentElement.scrollLeft;
            if (placementY === "bottom") {
                setMaxHeight(window.innerHeight - containerRect.bottom - 20);
            }
            if (placementY === "top") {
                setMaxHeight(window.innerHeight - containerRect.top + 40
                // - 2 * document.documentElement.scrollTop
                );
            }
            // check for space on the bottom
            if ((placementY === "auto" && offsetTop + menuRect.height > window.innerHeight) ||
                placementY === "top") {
                offsetTop = containerRect.top - menuRect.height - 5; //+ document.documentElement.scrollTop
            }
            setOffsets({ offsetTop, offsetLeft });
        }
    }, [menuRef, containerRef, placementX, placementY]);
    useEffect(() => {
        isOpen
            ? window.addEventListener("resize", recalculatePosition)
            : window.removeEventListener("resize", recalculatePosition);
        // Disable scroll & fix page resize on menu open
        document.body.style.marginRight =
            isOpen && window.innerWidth > document.body.clientWidth ? "19px" : "";
        document.body.style.overflow = isOpen ? "hidden" : "";
        recalculatePosition();
        return () => {
            window.removeEventListener("resize", recalculatePosition);
        };
    }, [isOpen, recalculatePosition]);
    useEffect(() => {
        const portal = portalRef.current;
        const handleClick = (ev) => ev.target === portal && onClose();
        isOpen
            ? portal === null || portal === void 0 ? void 0 : portal.addEventListener("click", handleClick)
            : portal === null || portal === void 0 ? void 0 : portal.removeEventListener("click", handleClick);
        return () => portal === null || portal === void 0 ? void 0 : portal.removeEventListener("click", handleClick);
    }, [isOpen, onClose]);
    return (_jsxs(_Fragment, { children: [renderButton(containerRef), isOpen
                ? createPortal(_jsx("div", Object.assign({ ref: portalRef, className: "portal-background" }, { children: _jsx("div", Object.assign({ ref: menuRef, className: clsx("iui-menu", className, size), style: {
                            top: offsets.offsetTop + "px",
                            left: offsets.offsetLeft + "px",
                            maxHeight: maxHeight || undefined,
                        } }, { children: children })) })), document.body)
                : null] }));
};
